import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import SEO from '../components/SEO';

const Cookies = () => {
  const { language, t } = useLanguage();

  const seoData = {
    es: {
      title: 'Política de Cookies | PASTORIA SERRALTA, S.L.',
      description: 'Política de cookies de PASTORIA SERRALTA, S.L. Información sobre las cookies utilizadas en nuestro sitio web y cómo gestionarlas.'
    },
    en: {
      title: 'Cookies Policy | PASTORIA SERRALTA, S.L.',
      description: 'Cookies policy of PASTORIA SERRALTA, S.L. Information about cookies used on our website and how to manage them.'
    }
  };

  return (
    <div className="min-h-screen bg-white" data-testid="cookies-page">
      <SEO 
        title={seoData[language].title}
        description={seoData[language].description}
        url={language === 'es' ? '/cookies' : '/en/cookies'}
        noindex={false}
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl sm:text-5xl font-bold text-[#363636] mb-8" data-testid="cookies-title">
          {t.cookies.title}
        </h1>
        <div 
          className="prose prose-lg max-w-none text-gray-700"
          dangerouslySetInnerHTML={{ __html: t.cookies.content }}
          data-testid="cookies-content"
        />
      </div>
    </div>
  );
};

export default Cookies;